// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Belgium */
const BE = /^(?:4[5-9]\d{7})$/;

export default BE;
